import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { RouteParams } from '@/router/type';
import { useGetServerlessToken } from '@/service/serverless-gpu/hook';
import { useAppState } from '@/store/app-state';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useServerlessStore } from '@/store/serverless';

const ProviderServerlessToken = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { workspaceId } = useParamWorkspaceId();
  const setServerlessToken = useServerlessStore(
    (state) => state.setServerlessToken
  );
  const { loading } = useServerlessStore();

  const { data, isLoading } = useGetServerlessToken(
    {
      workspace_id: workspaceId!,
    },
    {
      retry: (failureCount, error: any) => {
        if (error?.response?.data?.details === 'Not found serverless token') {
          return false;
        }
        return failureCount < 3;
      },
      staleTime: 1000 * 60 * 5,
    }
  );

  useEffect(() => {
    if (!isLoading) {
      setServerlessToken(data?.token || null);
    }
  }, [data?.token, isLoading]);

  if (loading) {
    return <></>;
  }
  return children;
};

export default ProviderServerlessToken;
